import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';

import leaflet from 'leaflet';

const styles = (theme) => {
    return {
        background: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            '&$resMid': {
                backgroundImage:
                    'repeating-linear-gradient(0deg,transparent,transparent 20px,#CCCCCCDD 20px,#CCCCCCDD 21px),' +
                    'repeating-linear-gradient(-90deg,transparent,transparent 20px,#CCCCCCDD 20px,#CCCCCCDD 21px)',
                backgroundSize: '21px 21px',
            },
            '&$resHigh': {
                backgroundImage:
                    'repeating-linear-gradient(0deg,transparent,transparent 40px,#CCCCCCDD 40px,#CCCCCCDD 41px),' +
                    'repeating-linear-gradient(-90deg,transparent,transparent 40px,#CCCCCCDD 40px,#CCCCCCDD 41px)',
                backgroundSize: '41px 41px',
            }
        },
        resMid: {},
        resHigh: {},
    }
}

class GridOverlay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoomLevel: 0,
        }

        this.props.map.on({
            zoomend: this._handleZoomEnd,
        });
    }

    componentWillUnmount = () => {
        this.props.map.off({
            zoomend: this._handleZoomEnd,
        });
    }

    render = () => {
        if (!this.props.show || this.state.zoomLevel < 17) {
            return null;
        }

        const {classes} = this.props;

        return (
            <div className={classNames(this.props.className, classes.background,
                (this.state.zoomLevel === 17) ? classes.resMid : classes.resHigh)}/>
        )
    }

    _handleZoomEnd = (e) => {
        const z = this.props.map.getZoom();

        this.setState({zoomLevel: z});
    }
}

GridOverlay.propTypes = {
    map: PropTypes.instanceOf(leaflet.Map).isRequired,
    show: PropTypes.bool.isRequired
}

export default withStyles(styles)(GridOverlay);
